import { useEffect, useState } from "react";

export default function useManualTrack(nowPlaying, audioTimeMs) {
    const [manualTrack, setManualTrack] = useState(null);
    const [isSeeking, setIsSeeking] = useState(false);

    function parseDuration(durationStr) {
        if (!durationStr) return 0;
        const parts = durationStr.split(":").map(Number);
        if (parts.length === 2) {
            return parts[0] * 60 + parts[1];
        }
        return 0;
    }

    useEffect(() => {
        if (!nowPlaying?.history?.length) return;

        const tracks = nowPlaying.history.map((track) => {
            const start = new Date(track.startedAt).getTime();
            const end = start + parseDuration(track.duration) * 1000;
            return { ...track, start, end };
        });

        const matched = tracks.find(
            (track, i) =>
                audioTimeMs >= track.start &&
                (i === 0 || audioTimeMs < (tracks[i - 1]?.start || Infinity))
        );

        if (matched && matched.startedAt !== manualTrack?.startedAt) {
            setManualTrack(matched);
            setIsSeeking(true);
        }
    }, [audioTimeMs, nowPlaying]);

    return { manualTrack, setManualTrack, isSeeking, setIsSeeking };
}
